'use strict';

const { h } = require('phy');
const { pruneData } = require('../../../modules/support/prune-data.js');

const CouponUber = require('./coupon-uber');
const CouponTile = require('./coupon-tile');

const AMOUNT_TO_PRELOAD = 4;

function getListTiles({ coupons, routes, media, referralSource }) {
  if (!coupons || !coupons.length) {
    return null;
  }

  return h(
    'ul.coupons-list',
    coupons.map((coupon, index) =>
      h(
        'li.coupons-list-row',
        CouponTile({
          coupon,
          media,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms',
            'merchant:show'
          ),
          lazy: index >= AMOUNT_TO_PRELOAD,
          referralSource,
        })
      )
    )
  );
}

function CouponsList({
  premium = [],
  coupons,
  routes,
  media = 'logo',
  referralSource = '',
  showUberOffer,
  attrs = {},
}) {
  return h(
    '',
    attrs,
    premium.map(coupon =>
      h(
        '.coupons-list-row',
        CouponUber({
          coupon,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms'
          ),
          referralSource,
          showUberOffer,
        })
      )
    ),
    getListTiles({ coupons, routes, media, referralSource })
  );
}

module.exports = CouponsList;
